<template>
  <!-- 处方申请 -->
  <div class="returnList">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="getTableData('refresh')"
      :crumbsList="['订单管理', $route.meta.title]"
    >
      <template slot="controls">
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">订单状态：</label>
        <el-select
          placeholder="订单状态"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.status"
        >
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <label class="label">支付方式：</label>
        <el-select
          placeholder="支付方式"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.payId"
        >
          <el-option label="全部" :value="99"></el-option>
          <el-option
            v-for="(item, index) in payTypeList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-date-picker
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          clearable
          v-model="searchForm.start"
          style="width: 200px; margin-right: 5px"
          placeholder="选择开始日期"
        >
        </el-date-picker>
        <el-date-picker
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          clearable
          v-model="searchForm.end"
          style="width: 200px; margin-right: 5px"
          placeholder="选择结束日期"
        >
        </el-date-picker>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入订单号/客户名称"
          v-model="searchForm.name"
        >
        </el-input>
        <el-button
          type="primary"
          icon="el-icon-search"
          v-if="buttonVisibility.search"
          @click="getTableData('search')"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
      @expand-change="getOrderDetail"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="BizID"
        align="center"
        width="150"
        show-overflow-tooltip
        label="订单号"
      >
      </el-table-column>
      <el-table-column
        prop="DoctorName"
        align="center"
        width="220"
        show-overflow-tooltip
        label="医生名字"
      >
      </el-table-column>
      <el-table-column
        prop="DoctorTime"
        label="开方时间"
        align="center"
        show-overflow-tooltip
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="Enjoin"
        label="医嘱"
        align="center"
        show-overflow-tooltip
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="Id"
        label="主键id"
        align="center"
        show-overflow-tooltip
        width="100"
      >
      </el-table-column>
      <el-table-column
        prop="NotPassReason"
        label="不通过原因"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="PatientName"
        label="患者姓名"
        align="center"
        show-overflow-tooltip
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="PharmacistName"
        label="药师名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="PharmacistTime"
        label="审方时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="PrimaryDiagnosis"
        label="主诊断"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="RpID"
        label="处方ID"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="RpPDFUrl"
        label="处方pdf文件地址"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="RpStatus"
        label="处方状态"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="RpTypeName"
        label="处方类别名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="SectionName"
        label="科室名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="TotalDoses"
        label="总剂"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="UserName"
        label="用户名"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <!-- <el-table-column
          prop="RetImg"
          label="凭证"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div v-if="scope.row.retImgList && scope.row.retImgList.length > 0" class="voucher-images">
                <div class="image-container">
                   <div 
                      class="image-item" 
                      v-for="(img, index) in scope.row.retImgList" 
                      :key="index"
                      @click.stop="previewImage(img.RetImg)"
                    >
                      <img :src="img.RetImg" alt="凭证图片" />
                    <div class="image-index">图{{ img.index }}</div>
                </div>
                </div>
              <div class="image-tip">点击图片可放大查看</div>
            </div>
            <div v-else class="no-images">
              暂无图片
            </div>
          </template>
      </el-table-column> -->
      <el-table-column
        prop="Remark"
        label="客户备注"
        align="center"
        show-overflow-tooltip
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="AuditStatus"
        label="审核状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.AuditStatus == 0">待审核</el-tag>
          <el-tag type="danger"  v-else-if="scope.row.AuditStatus == 1"
            >审核拒绝</el-tag
          >
          <el-tag type="success" v-else-if="scope.row.AuditStatus == 2"
            >审核通过</el-tag
          >
          <el-tag type="info" v-else>未定义</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="200"
        align="center"
        fixed="right"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-button type="success" 
            @click="handleRudit(scope)"
            style="padding: 2px 3px"
            plain
            v-if="buttonVisibility.audit"
          >审核</el-button>
          <el-button type="primary" 
            @click="getOrderDetail(scope)"
            style="padding: 2px 3px"
            plain
            v-if="buttonVisibility.details"
          >药品明细</el-button>
          <el-button type="primary" 
            @click="viewPrescriptionPDF(scope)"
            style="padding: 2px 3px"
            plain
            v-if="buttonVisibility.pdf"
          >电子处方</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 药品明细弹窗 -->
    <el-dialog
      title="药品明细"
      :visible.sync="goodsDialog"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="800px"
    >
      <el-table
        :data="MedicinesDetail"
        stripe
        border
        height="300px"
        tooltip-effect="dark"
      >
        <el-table-column
          prop="BizID"
          label="三⽅订单标志"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="Course"
          label="疗程"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="GoodsID"
          label="商品ID"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="MedicationDays"
          label="用药天数"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="MedicineAmount"
          label="药品数量"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="MedicineClassName"
          label="药品类型"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="MedicineName"
          label="药品名称"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="Mimo"
          label="备注"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="Specification"
          label="药品规格"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="TakeDirection"
          label="服用方式"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="TakeDose"
          label="服用剂量"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="TakeFrequence"
          label="服用频次"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 查看电子处方弹窗 -->、
    <!-- <el-dialog
      title="电子处方"
      :visible.sync="pdfDialogVisible"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="80%"
      top="5vh"
      class="pdf-preview-dialog"
    >
      <div class="pdf-preview-content">
        <iframe 
          :src="pdfUrl" 
          frameborder="0" 
          width="100%" 
          height="70vh"
          style="border: none;"
        ></iframe>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="pdfDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>   -->

    <!-- 图片预览弹窗 -->
    <el-dialog :visible.sync="previewVisible" :close-on-click-modal="false" width="80%" top="5vh"
      class="image-preview-dialog">
      <div class="preview-content">
        <img :src="currentPreviewImage" alt="预览图片" class="preview-image" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="previewVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: "returnList",
  data() {
    return {
      tableData: [],
      MedicinesDetail : [], //药品明细
      retImgList:[], //凭证图片 
      currentPreviewImage: "", //当前预览图片
      previewVisible: false, //图片预览弹窗是否显示
      options: [
        { value: "99", label: "全部" },
        { value: "0", label: "已拒审" },
        { value: "1", label: "待审核" },
        { value: "2", label: "已审核" },
      ],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**搜索表单 */
      searchForm: {
        status: "99",
        name: "",
        // payId: 99, //支付方式
        start: "", //起始日期
        end: "", //截止日期
      },

      /**支付方式 */
      payTypeList: [],

      /**退货详情 */
      details: [],
      goodsDialog: false,
      selectRow: {},
      /**电子处方弹窗 */
      pdfDialogVisible: false,
      pdfUrl: "", //电子处方url
      pdLoading: false,
      pdfPages:[],
      pdfDoc:null,
    };
  },
  computed: {
    // 按钮权限
    ...mapState(['buttonPermissions']),
    buttonVisibility() {
      const buttonsLimit = this.buttonPermissions?.['处方审核'] || [];
      // console.log('buttonsLimit', buttonsLimit);
      return {
        search: buttonsLimit.includes('搜索'),
        audit: buttonsLimit.includes('审核'),
        details: buttonsLimit.includes('药品明细'),
        pdf: buttonsLimit.includes('电子处方'),
      }
    }

  },
  mounted() {
    this.getTableData();
    this.getPayType();
  },
  methods: {
    /**获取支付方式id */
    getPayType() {
      let data = {
        entId: localStorage.getItem("entId"),
      };
      this.$request({
        url: "Base/GetEntPayTypeList",
        method: "post",
        data: data,
      }).then((res) => {
        if (res.success) {
          this.payTypeList = res.list.map((item) => ({
            label: item.PayType,
            value: item.PayId,
          }));
        } else {
          this.$message({
            message: res.message,
            type: "error",
          });
        }
      });
    },

    /**获取表格数据 */
    getTableData(type) {
      if (type == "refresh") {
        this.currPage = 1;
        this.searchForm.name = "";
        this.searchForm.start = "";
        this.searchForm.end = "";
        this.searchForm.payId = 99;
      } else if (type == "search") {
        this.currPage = 1;
      }

      let data = {
        RpStatus: this.searchForm.status,
        searchVal: this.searchForm.name,
        startData: this.searchForm.start,
        endData: this.searchForm.end,
        pageIndex: this.currPage,
        pageSize: this.pageSize,
        payId: this.searchForm.payId,
      };

      this.$request({
        method: "post",
        url: "Order/QueryUnverifiedPrescription",
        data,
      })
        .then((res) => {
          if (res.dataList && res.dataList.length > 0) {
            this.tableData = res.dataList;
            this.allPage = res.toTal;

            // if (this.tableData && this.tableData.length > 0) {
            //   this.tableData = this.tableData.map((item =>{
            //     if (item.RetImg && typeof item.RetImg == "string") {
            //     const imgUrls = item.RetImg.split(',').map(url => url.trim());
            //     const validImgUrls = imgUrls.filter(url => url.length > 0);
            //     return {
            //       ...item,
            //       retImgList: validImgUrls.map((imgUrl, index) => ({
            //       RetImg: this.$setImgUrl(imgUrl),
            //       index: index + 1
            //       }))
            //     }
            //   }
            //   return {
            //     ...item,
            //     retImgList: []
            //   }
            //   }))
            // }
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**查询药品明细 */
    getOrderDetail({ row }) {
      this.selectRow = row;
      this.$request({
        method: "post",
        url: "/Order/QueryUnverifiedPrescription",
        data: {
          orderNo: row.OrderNo,
        },
      })
        .then((res) => {
          if (res.success) {
            this.goodsDialog = true;
            this.details = res.dataList;
            if(res.dataList && res.dataList.length > 0) {
              this.MedicinesDetail = row.Medicines || [];
            }
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**查看电子处方 */
    viewPrescriptionPDF({ row }) {
      this.selectRow = row;
      if ( row.RpPDFUrl ) {
        let pdfUrl = row.RpPDFUrl;
        window.open(pdfUrl, '_blank');
        // if (pdfUrl.startsWith('http')) {
        //   // 方案：通过后端代理获取PDF
        //   pdfUrl = `/api/proxy/pdf?url=${encodeURIComponent(pdfUrl)}`;
        // } else if (!pdfUrl.startsWith('http') && !pdfUrl.startsWith('//')) {
        //   // 相对路径，直接拼接
        //   pdfUrl = this.$setImgUrl(pdfUrl);
        // }
        // this.pdfUrl = pdfUrl;
        // this.pdfDialogVisible = true;
        // console.log('this.pdfUrl',this.pdfUrl,'pdfUrl',pdfUrl);
      }
      else {
        this.$message.error('该处方暂无电子处方');
      }
    },
    

    /**预览图片 */
    previewImage(imgUrl) {
      this.currentPreviewImage = imgUrl;
      this.previewVisible = true;
    },

    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },

    /**
     * 点击审核
     *
     */
    handleRudit(row) {
      this.$confirm("请选择审核结果", "提示", {
        confirmButtonText: "通过",
        cancelButtonText: "拒绝",
      })
        .then(() => {
         this.sendReview(row,'2') //点击通过
        })
        .catch(() => {
          this.sendReview(row,'1') //点击拒绝
        });
    },
    sendReview(row, status) {
      this.$request({
        method: "post",
        url: "Order/PrescriptionReview",
        data: {
          BizId: row.row.BizID,
          Status: status,
        },
      })
        .then((res) => {
          if (res.success) {
            this.$message.success(status === '2' ? '审核通过' : '审核拒绝')
            this.goodsDialog = false;
            this.getTableData();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          console.log('err',err);
        });
    },

    /**点击导出，暂时没有用到 */
    handleExport() {
      let startDate = "";
      let endDate = "";
      let status = this.searchForm.status;
      let txtStrWhere = this.searchForm.name;
      let userId = window.localStorage.getItem("userId");
      let entId = window.localStorage.getItem("entId");
      window.location.href =
        this.baseUrl +
        "/API/ToExcel/ToExceRefundOrderList?startDate=" +
        startDate +
        "&endDate=" +
        endDate +
        "&status=" +
        status +
        "&strWhere=" +
        txtStrWhere +
        "&userId=" +
        userId +
        "&entId=" +
        entId;
    },
  },
};
</script>

<style scoped>
.returnList {
  width: 100%;
  height: 100%;
}
/* 凭证图片样式 */
.voucher-images {
  padding: 10px 0;
}

.image-container {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  justify-content: center;
}

.image-item {
  width: 60px;
  height: 60px;
  position: relative;
  cursor: pointer;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #ddd;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.image-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
  border-color: #409EFF;
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-index {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  text-align: center;
  font-size: 10px;
  padding: 1px 0;
  line-height: 1.2;
}

.image-tip {
  font-size: 12px;
  color: #666;
  text-align: center;
  margin-top: 5px;
}

.no-images {
  color: #999;
  font-style: italic;
  text-align: center;
  padding: 10px 0;
}

/* 图片预览弹窗样式 */
.preview-content {
  text-align: center;
}

.preview-image {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
}

/* PDF预览弹窗样式 */
/* PDF预览弹窗样式 */
.pdf-preview-content {
  width: 100%;
  height: 100%;
}

.pdf-preview-content iframe {
  background-color: #f5f7fa;
}
</style>
